import {
	MimaButton,
	MimaDropdown,
	MimaText,
	MimaTextArea,
	Modal,
	PageLoader,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { amountFormatter } from '../../utils/utils';
import constant from '../../utils/constant';
import { Formik } from 'formik';
import moment from 'moment';
import React from 'react';

const ReviewPayroll = ({
	closeModal,
	requester,
	payrollSummary,
	onSubmit,
	loading,
	action,
	validationSchema,
	tag,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			{loading ? (
				<PageLoader title="while we fetch your records" loading={loading} />
			) : (
				<>
					{payrollSummary ? (
						<>
							<MimaText
								mt={4}
								mb={2}
								variant="smallBold"
								align="center"
								width={38}
							>
								{`Payroll Summary for ${tag}`}
							</MimaText>
							<MimaText
								labelTitle="Your Total Payroll Net cost"
								mb={2}
								width={38}
							>
								{amountFormatter().format(payrollSummary.totalNet)}
							</MimaText>
							<MimaText labelTitle="Pay Day" mb={2} width={38}>
								{moment(payrollSummary.payDay).format('Do MMMM, YYYY')}
							</MimaText>
							<MimaText labelTitle="Number of Employees" mb={2} width={38}>
								{`Total Employees ${payrollSummary.totalEmployees}`}
							</MimaText>
							<div className={styles.ps__breakdown}>
								<table>
									<thead>
										<tr className={styles.ps__breakdown_bdr}>
											<th>Breakdown</th>
											<th>Amount</th>
										</tr>
									</thead>
									<tbody>
										<tr className={styles.ps__breakdown_bdr}>
											<td>Initial Salary Gross</td>
											<td>
												{amountFormatter().format(
													payrollSummary.totalInitialGrossPay
												)}
											</td>
										</tr>
										<tr className={styles.ps__breakdown_sm}>
											<td>PAYE Tax</td>
											<td>
												-{amountFormatter().format(payrollSummary.totalTax)}
											</td>
										</tr>
										<tr className={styles.ps__breakdown_sm}>
											<td>WHT</td>
											<td>
												-{amountFormatter().format(payrollSummary.totalWHT)}
											</td>
										</tr>
										<tr
											className={`${styles.ps__breakdown_sm} ${styles.ps__breakdown_bdr}`}
										>
											<td>Pension</td>
											<td>
												-{amountFormatter().format(payrollSummary.totalPension)}
											</td>
										</tr>
										<tr
											className={`${styles.ps__breakdown_sm} ${styles.ps__breakdown_bdr}`}
										>
											<td>NHF</td>
											<td>
												-{amountFormatter().format(payrollSummary.totalNHF)}
											</td>
										</tr>
										{payrollSummary?.deductions?.map(deduction => (
											<tr className={styles.ps__breakdown_sm}>
												<td>{deduction.type}</td>
												<td>-{amountFormatter().format(deduction.amount)}</td>
											</tr>
										))}
										<tr
											className={`${styles.ps__breakdown_sm} ${styles.ps__breakdown_bdr}`}
										>
											<td>Other Deductions</td>
											<td>
												-{amountFormatter().format(payrollSummary.totalOtherDeductions)}
											</td>
										</tr>

										{payrollSummary?.additions?.map(sum => (
											<tr className={styles.ps__breakdown_sm}>
												<td>{sum.type}</td>
												<td>{amountFormatter().format(sum.amount)}</td>
											</tr>
										))}
										<tr>
											<td> Total Additions</td>
											<td>
												{amountFormatter().format(payrollSummary.extraAddition)}
											</td>
										</tr>
										<tr>
											<th>Total</th>
											<th>{amountFormatter().format(payrollSummary.totalNet)}</th>
										</tr>
									</tbody>
								</table>
							</div>

							{requester === constant.MakerCheckerUserType.REQUESTER &&
								action === constant.STATUS.VOID && (
									<>
										<Formik
											initialValues={{
												tag,
												comment: '',
												action: constant.STATUS.VOID,
												userType: constant.MakerCheckerUserType.REQUESTER,
											}}
											validationSchema={validationSchema}
											onSubmit={onSubmit}
										>
											{({
												handleSubmit,
												handleChange,
												handleBlur,
												values,
												errors,
												touched,
											}) => (
												<>
													<MimaTextArea
														type="textarea"
														labelTitle="Comment"
														placeholder="Enter Comment"
														name="comment"
														mb={2}
														variant="message"
														error={errors.comment}
														touched={touched.comment}
														value={values.comment}
														onChange={handleChange}
														onBlur={handleBlur}
													/>
													<MimaButton
														title="VOID"
														onClick={handleSubmit}
														type="submit"
														loading={loading}
														mt={2}
													/>
												</>
											)}
										</Formik>
									</>
								)}
							{requester === constant.MakerCheckerUserType.REQUESTER &&
								action !== constant.STATUS.VOID && (
									<>
										<Formik
											initialValues={{
												tag,
												comment: '',
												action: 'REQUEST REVIEW',
												userType: constant.MakerCheckerUserType.REQUESTER,
											}}
											validationSchema={validationSchema}
											onSubmit={onSubmit}
										>
											{({
												handleSubmit,
												handleChange,
												handleBlur,
												values,
												errors,
												touched,
											}) => (
												<>
													<MimaTextArea
														type="textarea"
														labelTitle="Comment"
														placeholder="Enter Comment"
														name="comment"
														mb={2}
														variant="message"
														error={errors.comment}
														touched={touched.comment}
														value={values.comment}
														onChange={handleChange}
														onBlur={handleBlur}
													/>
													<MimaButton
														title="Request Review"
														onClick={handleSubmit}
														type="submit"
														loading={loading}
														mt={2}
													/>
												</>
											)}
										</Formik>
									</>
								)}
							{requester === constant.MakerCheckerUserType.REVIEWER && (
								<>
									<Formik
										initialValues={{
											tag,
											comment: '',
											action: '',
											userType: constant.MakerCheckerUserType.REVIEWER,
										}}
										validationSchema={validationSchema}
										onSubmit={onSubmit}
									>
										{({
											handleSubmit,
											handleChange,
											handleBlur,
											setFieldValue,
											values,
											errors,
											touched,
										}) => (
											<>
												<MimaDropdown
													labelTitle="Action"
													placeholder="Select"
													name="action"
													value={values.action}
													id="action"
													onChange={data => {
														setFieldValue('action', data.key);
													}}
													data={[
														{
															key: constant.STATUS.REQUEST_CHANGE,
															value: constant.STATUS.REQUEST_CHANGE,
														},
														{
															key: 'REQUEST APPROVAL',
															value: 'REQUEST APPROVAL',
														},
													]}
													error={errors.action}
													touched={touched.action}
												/>
												<MimaTextArea
													type="textarea"
													labelTitle="Comment"
													placeholder="Enter Comment"
													name="comment"
													mb={2}
													variant="message"
													error={errors.comment}
													touched={touched.comment}
													value={values.comment}
													onChange={handleChange}
													onBlur={handleBlur}
												/>
												<MimaButton
													title="Submit"
													onClick={handleSubmit}
													type="submit"
													loading={loading}
													mt={2}
												/>
											</>
										)}
									</Formik>
								</>
							)}
							{requester === constant.MakerCheckerUserType.APPROVER && (
								<>
									<Formik
										initialValues={{
											tag,
											comment: '',
											action: '',
											userType: constant.MakerCheckerUserType.APPROVER,
										}}
										validationSchema={validationSchema}
										onSubmit={onSubmit}
									>
										{({
											handleSubmit,
											setFieldValue,
											handleBlur,
											handleChange,
											values,
											errors,
											touched,
										}) => (
											<>
												<MimaDropdown
													labelTitle="Action"
													placeholder="Select"
													name="action"
													value={values.action}
													id="action"
													onChange={data => {
														setFieldValue('action', data.key);
													}}
													data={[
														{
															key: constant.STATUS.REQUEST_CHANGE,
															value: constant.STATUS.REQUEST_CHANGE,
														},
														{ key: constant.STATUS.APPROVED, value: 'APPROVE' },
													]}
													error={errors.action}
													touched={touched.action}
												/>
												<MimaTextArea
													type="textarea"
													labelTitle="Comment"
													placeholder="Enter Comment"
													name="comment"
													mb={2}
													variant="message"
													error={errors.comment}
													touched={touched.comment}
													value={values.comment}
													onChange={handleChange}
													onBlur={handleBlur}
												/>
												<MimaButton
													title="Submit"
													onClick={handleSubmit}
													type="submit"
													loading={loading}
													mt={2}
												/>
											</>
										)}
									</Formik>
								</>
							)}
						</>
					) : (
						<MimaText mb={2}>No Record Found!</MimaText>
					)}
				</>
			)}
		</Modal>
	);
};

export default ReviewPayroll;
